/**
 * What is genuinely WAITING ON the investor.
 *
 * The dashboard used to sum two counters while rendering three rows, so the
 * header could read "All caught up!" directly above a live item, and with zero
 * new deals it advertised "0 new startups to review" — an action item for
 * nothing. Returning one array that is both counted and mapped makes that
 * class of bug unrepresentable: a list cannot desync from its own length.
 *
 * Discovery is deliberately absent. Pending means something is waiting on you;
 * browsing is what you do when nothing is.
 */
/**
 * Founder responses to access requests are DELIBERATELY not here, though the
 * spec lists them. There is no read-state on `data_room_access_requests`, so a
 * "responded" row can never be dismissed — it would sit in Pending Actions
 * forever. An item you cannot clear is precisely the defect this module exists
 * to remove. Add it when the table carries a seen/acknowledged column.
 */
export type PendingActionKind = 'due-diligence' | 'messages';

export interface PendingAction {
  kind: PendingActionKind;
  count: number;
}

export interface PendingActionsInput {
  pendingDueDiligence: number;
  unreadMessages: number;
}

export function buildPendingActions(input: PendingActionsInput): PendingAction[] {
  const rows: PendingAction[] = [
    { kind: 'due-diligence', count: input.pendingDueDiligence },
    { kind: 'messages', count: input.unreadMessages },
  ];
  return rows.filter((row) => row.count > 0);
}
